import { Component, DestroyRef, inject, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { MatDialog } from '@angular/material/dialog'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { ModeloDocumento } from './modelo-documento.model'
import { ModeloDocumentoService } from './modelo-documento.service'
import { ModeloStepperDialogComponent } from './modelo-stepper-dialog.component'

export interface GrupoModelos {
  categoria: string
  modelos: ModeloDocumento[]
}

@Component({
  selector: 'app-lista-modelos',
  templateUrl: './lista-modelos.component.html',
  styleUrls: ['./lista-modelos.component.scss'],
})
export class ListaModelosComponent implements OnInit {
  private destroyRef = inject(DestroyRef)
  modelos: ModeloDocumento[] = []
  gruposFiltrados: GrupoModelos[] = []
  filtro = ''
  loading = true
  erro = false
  concursoId!: number

  private readonly ordemCategorias = [
    'Atas de Provas',
    'Resultados e Recursos',
    'Editais e Publicações',
    'Inscrições',
  ]

  constructor(
    private service: ModeloDocumentoService,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    ;(this.route.parent?.params || this.route.params).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      this.concursoId = +params['id']
      this.carregar()
    })
  }

  carregar(): void {
    this.loading = true
    this.erro = false
    this.service.listar(this.concursoId).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: m => {
        this.modelos = m
        this.loading = false
        this.filtrar()
      },
      error: () => {
        this.modelos = []
        this.gruposFiltrados = []
        this.loading = false
        this.erro = true
      }
    })
  }

  filtrar(): void {
    const termo = this.normalizar(this.filtro)
    const filtrados = termo
      ? this.modelos.filter(m =>
          this.normalizar(m.titulo).includes(termo) ||
          this.normalizar(m.descricao).includes(termo) ||
          this.normalizar(m.categoria).includes(termo))
      : this.modelos

    const mapa = new Map<string, ModeloDocumento[]>()
    for (const m of filtrados) {
      const lista = mapa.get(m.categoria) || []
      lista.push(m)
      mapa.set(m.categoria, lista)
    }

    this.gruposFiltrados = this.ordemCategorias
      .filter(cat => mapa.has(cat))
      .map(cat => {
        const modelos = mapa.get(cat)!
        modelos.sort((a, b) => {
          if (a.disponivel !== b.disponivel) return a.disponivel ? -1 : 1
          return a.titulo.localeCompare(b.titulo)
        })
        return { categoria: cat, modelos }
      })
  }

  trackByCategoria(_: number, grupo: GrupoModelos): string {
    return grupo.categoria
  }

  trackByTipo(_: number, modelo: ModeloDocumento): string {
    return modelo.tipo
  }

  abrir(modelo: ModeloDocumento): void {
    this.dialog.open(ModeloStepperDialogComponent, {
      data: { concursoId: this.concursoId, tipo: modelo.tipo },
      width: '90vw',
      maxWidth: '1200px',
      height: '90vh',
      panelClass: 'fullheight-dialog',
      autoFocus: false,
    })
  }

  private normalizar(texto: string): string {
    return texto.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  }
}
